// Helper function to safely access nested object properties
export const getNestedValue = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj: Record<string, any>,
  path: string
): unknown => {
  if (obj == null || typeof path !== 'string') {
    return undefined;
  }
  return path.split('.').reduce((current: unknown, key: string) => {
    return current && typeof current === 'object' && current !== null
      ? current[key]
      : undefined;
  }, obj);
};
